import { useMemo } from 'react'
import { SymptomTrend } from '@estercare/ester-shared'
import { useGetSymptomProgressQuery } from '../api/ester-b2b-api/private/symptomProgress/symptomProgressQueries'

export const useSymptomCounts = () => {
  const { data } = useGetSymptomProgressQuery()
  return useMemo(() => {
    const ratings = data?.symptomRatings ?? []
    return {
      improved: ratings.filter((r) => r.status === SymptomTrend.Improving).length,
      stable: ratings.filter((r) => r.status === SymptomTrend.Stable).length,
      needs_attention: ratings.filter((r) => r.status === SymptomTrend.NeedsAttention).length,
    }
  }, [data])
}
